import { css, SerializedStyles } from "@emotion/react";
import { Tooltip } from "@material-ui/core";
import { Clear, MoreHoriz, Search } from "@material-ui/icons";
import styled from "../../../../config/emotion";
import { StyledCompProps } from "../../../../globalTypes/theme";

export const inputWrapperCss = css`
  width: 100%;
  max-width: 100px;

  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
`;

export const inputFieldCss = (
  disabled: boolean,
  hasError: boolean
): SerializedStyles => css`
  line-height: 1.5em;
  border-radius: 25px;
  border: 1px solid #ced4da;
  background: white;
  font-size: 1rem;
  padding: 0 5px;
  ${hasError && "border: 1px solid red"};
  width: 100%;

  input {
    cursor: ${disabled ? "text" : "pointer"};
  }

  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
`;

export const modalCss = css`
  display: flex;
  justify-content: center;
  align-items: center;

  .MuiDialog-paperWidthSm {
    max-width: 1280px;
  }
`;

export const modalCssMobile = css`
  height: 100vh;
  width: 100vw;

  .MuiDialog-paperWidthSm {
    width: 100vw;
    height: 100vh;
    max-height: unset;
  }
`;

export const addParameterFormCss = css`
  background-color: white;
  border-radius: 12px;
  min-width: 320px;
  min-height: 320px;
`;

export const modalHeaderCss = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #ced4da;
  width: 100%;

  color: rgb(46, 94, 150);
  font-weight: 500;
`;

export const modalBodyCss = css`
  padding: 12px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const mobileModalBodyCss = css`
  padding: unset;
`;

export const HTMLTooltip = styled(Tooltip)<StyledCompProps>`
  cursor: ${({ active }): string => (active ? "cursor" : "default")};
`;

export const TooltipContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const MoreIcon = styled(MoreHoriz)<StyledCompProps>`
  color: ${({ theme }): string => theme.colors.secondaryColor};

  &:hover {
    color: ${({ theme, active }): string =>
      active ? theme.colors.primaryColor : theme.colors.secondaryColor};
  }
`;

export const ClearIcon = styled(Clear)<StyledCompProps>`
  color: ${({ theme }): string => theme.colors.secondaryColor};
  cursor: pointer;
  width: 15px !important;
  height: 15px !important;

  &:hover {
    color: ${({ theme }): string => theme.colors.primaryColor};
  }
`;

export const SearchIcon = styled(Search)<StyledCompProps>`
  cursor: pointer;

  color: ${({ theme }): string => theme.colors.secondaryColor};
`;

export const adornmentOverrideCss = css`
  width: auto !important;
`;

export const footerContainerCss = css`
  width: 100%;
  padding: 0.5rem;
  text-align: center;
`;
